import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import AddWithGroup from "./AddWithGroup/AddWithGroup";
import AddwithWord from "./AddwithWord/AddwithWord";
import AddAllWord from "./AddAllWord/AddAllWord";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      style={{ width: "100%" }}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function AddToLeitner() {
  const [value, setValue] = React.useState(0);
  const [groupActiveStep, setGroupActiveStep] = React.useState(0);
  const [wordActiveStep, setWordActiveStep] = React.useState(0);
  const [allWordActiveStep, setAllWordActiveStep] = React.useState(0);

  const handleGroupNext = () => {
    // console.log("groupActiveStep", groupActiveStep);
    setGroupActiveStep((prevActiveStep) => prevActiveStep + 1);
    setWordActiveStep(0);
    setAllWordActiveStep(0);
  };
  const handleGroupBack = () => {
    setGroupActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const handleWordNext = () => {
    setWordActiveStep((prevActiveStep) => prevActiveStep + 1);
    setAllWordActiveStep(0);
    setGroupActiveStep(0);
  };
  const handleWordBack = () => {
    setWordActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleAllWordNext = () => {
    setAllWordActiveStep((prevActiveStep) => prevActiveStep + 1);
    setWordActiveStep(0);
    setGroupActiveStep(0);
  };
  const handleAllWordBack = () => {
    setAllWordActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Typography
        sx={{
          flexGrow: 1,
          bgcolor: "background.paper",
          color: (theme) => theme.palette.reverse.dark,
          display: "flex",
        }}
      >
        انتخاب لغات بر اساس:
      </Typography>
      <Divider />
      <Box
        sx={{
          //   flexGrow: 1,
          flex: "100%",
          bgcolor: "background.paper",
          display: "flex",
          height: " 100 vh",
        }}
      >
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          sx={{
            borderRight: 1,
            borderColor: "divider",
            width:
              groupActiveStep > 0 || wordActiveStep > 0 || allWordActiveStep
                ? "2px"
                : "68px",
          }}
        >
          <Tab label="همه" {...a11yProps(2)} />
          <Tab label="گروه" {...a11yProps(0)} />
          <Tab label="لغت" {...a11yProps(1)} />
        </Tabs>
        <TabPanel value={value} index={0}>
          <AddAllWord
            handleNext={handleAllWordNext}
            handleBack={handleAllWordBack}
            activeStep={allWordActiveStep}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <AddWithGroup
            handleNext={handleGroupNext}
            handleBack={handleGroupBack}
            activeStep={groupActiveStep}
          />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <AddwithWord
            handleNext={handleWordNext}
            handleBack={handleWordBack}
            activeStep={wordActiveStep}
          />
        </TabPanel>
      </Box>
    </>
  );
}
